/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable no-nested-ternary */

import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import {
    Grid, Typography, LinearProgress, Dialog, Button, IconButton, Slide,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import {
    bool, func, object, oneOfType, number, shape, arrayOf, string, node,
} from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { uid } from 'react-uid';
import { getAddToCartItemAdded } from '../../../../../../../../state/ducks/AddToCart/AddToCart-Selectors';

import CYOGroupsContainer from './CYOGroupsContainer';
import CYOGroup from './CYOGroup';
import CYOBandGroup from './CYOBandGroup';
import ConnectedGraphqlFoodAddToCart from '../../../GraphqlFoodAddToCart/GraphqlFoodAddToCart';
import GraphqlFoodProductDetailsTab from '../../../GraphqlFoodDetailsUI/GraphqlFoodDetailsUI';
import useClickAway from '../useClickAway';
import AddonDialog from '../../../GraphqlAddon/AddonDialog';
import { getFeatureFlag } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
    mainContainer: {

    },
    dialog: {
        zIndex: 9999999999,
    },
    makeSelectionBtn: {
        borderRadius: '50px',
        padding: '10px 20px 10px 20px',
        width: '100%',
        maxWidth: '360px',
        margin: '10px auto',
        backgroundColor: palette?.primaryButton || '#a1001a',
        color: palette?.getContrastText(palette?.primaryButton) || '#fff',
        fontWeight: '700',
        [breakpoints.down('xs')]: {
            margin: '0 10px 0 10px',

        },
    },
    productDetailsTab: {
        padding: '20px 10px 10px 10px',
    },
    productItemsContainer: {
        maxWidth: '1286px',
        margin: '0px auto',
        paddingBottom: '120px',
        [breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
    },
    progressCartContainer: {
        position: 'fixed',
        bottom: '0',
        left: '0',
        width: '100%',
        zIndex: 9999,
        background: palette?.background?.paper || '#fff',
    },
    progressBarRoot: {
        height: '24px',
        borderRadius: '0px',
        backgroundColor: palette?.background?.paper || '#fff',
        margin: `0px ${spacing(2)}px`,
        boxShadow: '0px 3px 7px -1px rgba(0, 0, 0, 0.75)',
    },
    progressBarPrimColor: {
        backgroundColor: palette?.success?.main || '#57B560',
    },
    bannerError: {
        color: palette?.error.light || 'rgb(220, 30, 30)',
        margin: `${spacing(1)}px ${spacing(3)}px`,
    },
    itemNumbers: {
        margin: `${spacing(1)}px ${spacing(3)}px`,
    },
    cartButtonContainer: {
        paddingRight: spacing(4),
        paddingBottom: spacing(4),
        maxWidth: '350px',
        marginLeft: 'auto',
        '& button': {
            borderRadius: '20px',
        },
        [breakpoints.down('md')]: {
            paddingBottom: 'env(safe-area-inset-bottom)',
            marginBottom: spacing(2),
        },
        [breakpoints.down('xs')]: {
            padding: spacing(1),
            margin: 'auto',
            '& > div': {
                marginTop: '0px',
            },
        },
    },
    overlay: {
        right: '0',
        bottom: '0',
        top: '0',
        left: '0',
        backgroundColor: 'rgba(47, 47, 47, 0.3)',
        zIndex: '1',
        height: '100%',
        position: 'absolute',
    },
    addonDialog: {
        width: '100%',
        overflowY: 'scroll',
        maxHeight: '450px',
    },
}));

const MobileCYOProductItemsVTwo = ({
    handleMiniCartModalClick,
    brandId,
    deliverySLA,
    hasWine,
    product,
    handleMobileAgeVerification,
    selectedItemId,
    totalProductSelected,
    maxSelectableForSku,
    compileSelectedItems,
    itemAddedToCart,
    selectedAddons,

    cyoData,
    handleItemSelection,
    selectedItems,
    selectionError,
    clearError,
    handleDisabledInteraction,
    removeItem,
    hideMenu,
    handleSelectBand,
    handleRemoveBand,
    selectedBand,
    getPrettyGroupName,
    useGuided,
    activeIndex,
    handleAddedToCart,
    addonContainer,
    hasAddons,
}) => {
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const [scrollRef, setScrollRef] = useState();
    const cyoAddonEnabled =  useSelector(getFeatureFlag('is-cyo-addon-enabled'));
    const handleRef = (ref) => {
        setScrollRef(ref);
    };
    const location = useLocation();

    useEffect(() => {
        const itemAddedId = itemAddedToCart?.orderItemDetails?.productCode;
        if (
            itemAddedId === product.legacyId
            || itemAddedId === product.partNumber
            || itemAddedId === product.id
            || itemAddedId === product.selectedSku
        ) {
            handleAddedToCart();
            setOpen(false);
        }
    }, [itemAddedToCart]);
    const { ref, active, toggle } = useClickAway();
    const addonRef = useRef();

    useEffect(() => {
        if (totalProductSelected && maxSelectableForSku === totalProductSelected) {
            toggle();
        }
    }, [maxSelectableForSku, totalProductSelected]);
    const visibleGroups = cyoData.cyoGroup.filter((g) => g.type !== 'cyoNonCountable');
    const hasBand = !!(cyoData.cyoGroup[0]?.type === 'cyoBands' && cyoData.cyoGroup[0].name);
    return (
        <div className={classes.mainContainer} data-testid="cyoMobileItems">
            <Grid container>
                <Grid item xs={12} container justify="center">
                    <Button
                        variant="contained"
                        className={classes.makeSelectionBtn}
                        onClick={() => setOpen(!open)}
                    >
                        Make Your Selections
                    </Button>
                </Grid>
                <Grid item xs={12} className={classes.productDetailsTab}>
                    <GraphqlFoodProductDetailsTab
                        shortDescription={product?.shortDescription || ''}
                        productContents={product?.productContents || ''}
                        longDescription={product?.longDescription || ''}
                        productSkus={product?.productSkus || ''}
                        selectedSku={product?.productSkus[0]}
                    />
                </Grid>
            </Grid>

            <Dialog
                open={open}
                data-testid="cyoMobileSelectionDialog"
                fullScreen
                className={classes.dialog}
                PaperProps={{
                    ref: handleRef,
                }}
            >
                <CYOGroupsContainer
                    Container={Grid}
                    containerProps={{ container: true, className: classes.productItemsContainer }}
                    // Hide menu if instructed to or if a band sku and no band selected
                    hideMenu={hideMenu || (hasBand && !selectedBand.groupName)}
                    forcedIndex={activeIndex}
                    sticky
                    scrollElement={scrollRef}
                    showCloseIcon
                    renderCloseIcon={() => (
                        <IconButton onClick={() => setOpen(false)}><Close /></IconButton>
                    )}
                >
                    <div className={active && cyoAddonEnabled  && hasAddons ? `${classes.overlay}` : ''} />
                    {visibleGroups.map((group, i) => {
                        const prettyGroupName = getPrettyGroupName(group.name);
                        // TODO: simplify ternary
                        // If using guided, then only allow selection one at a time.
                        // If not, just force band selection first
                        const showItem = i === 0
                            ? true
                            : (useGuided
                                // If using guided, ensure previous item is complete
                                ?  !!selectedItems[visibleGroups[i - 1].name]?.completed || selectedBand?.groupName === visibleGroups[i - 1].name
                                : (hasBand
                                    ? selectedBand?.groupName === visibleGroups[0].name
                                    : true
                                )
                            );
                        return (group.type === 'cyoBands' ? (
                            <CYOBandGroup
                                key={uid(prettyGroupName)}
                                handleSelectBand={handleSelectBand}
                                handleRemoveBand={handleRemoveBand}
                                selectedBandID={selectedBand.itemID}

                                groupData={group}
                                selectionError={selectionError}
                                clearError={clearError}
                            />
                        ) : (
                            <CYOGroup
                                groupData={group}
                                key={uid(group.name)}
                                selectedItems={selectedItems[group.name] || {}}
                                handleItemSelection={handleItemSelection}
                                selectionError={selectionError}
                                handleDisabledInteraction={handleDisabledInteraction}
                                clearError={clearError}
                                removeItem={removeItem}
                                data-name={prettyGroupName}
                                disabled={!showItem}
                                showYourSelection={hasBand && i === 1}
                                selectionNumber={maxSelectableForSku}
                            />
                        ));
                    })}
                    <Grid item xs={12} container className={classes.progressCartContainer}>
                        { cyoAddonEnabled && hasAddons ?  (
                            <Slide direction="up" in={active}  unmountOnExit  container={addonRef.current}>
                                <div
                                    className={classes.addonDialog}
                                    ref={ref}
                                >
                                    <AddonDialog
                                        closeDialog={toggle}
                                        addonContainer={addonContainer}
                                    />
                                </div>
                            </Slide>
                        ) : ''}
                        <Grid item xs={12}>
                            <LinearProgress
                                classes={{
                                    root: classes.progressBarRoot,
                                    barColorPrimary: classes.progressBarPrimColor,
                                }}
                                variant="determinate"
                                value={totalProductSelected === 0 ? 0 : Math.round((totalProductSelected / maxSelectableForSku) * 100)}
                            />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            {
                                selectionError?.bannerError ? (
                                    <Typography className={classes.bannerError}>
                                        {selectionError.bannerError}
                                    </Typography>
                                ) : (
                                    <Typography className={classes.itemNumbers}>
                                        {`${totalProductSelected} of ${maxSelectableForSku} Items Selected`}
                                    </Typography>
                                )
                            }
                        </Grid>
                        <Grid item xs={0} lg={4} />
                        <Grid justify="flex-end" item xs={12} lg={4} className={classes.cartButtonContainer}>
                            <ConnectedGraphqlFoodAddToCart
                                handleMiniCartModalClick={handleMiniCartModalClick}
                                selectedItemId={selectedItemId}
                                brandId={brandId}
                                productType="cyo"
                                isMobile
                                disableAddToCart
                                totalProductSelected={totalProductSelected}
                                maxComponents={maxSelectableForSku}
                                /*
                        FORMAT:
                        {
                            brandCode: brandId,
                            productCode: id,
                            productId: legacyId,
                            quantity: number,
                            componentType: 'CYO'
                        }
                    */
                                cyoSelectedComponents={compileSelectedItems()}
                                partNumber={product.partNumber}
                                product={product}
                                // If this is a band product, use functionality, otherwise do not
                                isBandItemSelected={hasBand ? !!selectedBand.groupName : true}
                                hasWine={hasWine}
                                handleMobileAgeVerification={handleMobileAgeVerification}
                                deliveryMethod={deliverySLA}
                                deliveryIndicator=""
                                addons={selectedAddons}
                                categoryId={location?.state?.categoryId || ''}
                                categoryPath={location?.state?.categoryPath || ''}
                                categoryName={location?.state?.categoryName || ''}
                            />
                        </Grid>
                    </Grid>
                </CYOGroupsContainer>
            </Dialog>

        </div>
    );
};

MobileCYOProductItemsVTwo.propTypes = {
    brandId: string.isRequired,
    handleMiniCartModalClick: func.isRequired,
    deliverySLA: string.isRequired,
    product: object.isRequired,
    handleMobileAgeVerification: func.isRequired,
    totalProductSelected: number.isRequired,
    maxSelectableForSku: number.isRequired,
    cyoData: shape({
        maxQuantity: number.isRequired,
        cyoGroup: arrayOf(
            shape({
                name: string.isRequired,
                components: arrayOf(
                    shape({
                        id: string.isRequired,
                        legacyId: string.isRequired,
                        name: string.isRequired,
                        image: shape({
                            name: string.isRequired,
                            path: string.isRequired,
                        }),
                    }),
                ).isRequired,
            }),
        ).isRequired,
    }).isRequired,
    handleItemSelection: func.isRequired,
    selectedItems: object.isRequired,
    selectionError: object.isRequired,
    clearError: func.isRequired,
    handleDisabledInteraction: func.isRequired,
    removeItem: func.isRequired,
    handleSelectBand: func.isRequired,
    handleRemoveBand: func.isRequired,
    selectedBand: object.isRequired,
    compileSelectedItems: func.isRequired,
    handleAddedToCart: func.isRequired,
    selectedAddons: arrayOf(shape({
        brandCode: string,
        productCode: string,
        componentType: string,
        productId: string,
        quantity: number,
    })),
    itemAddedToCart: object,
    hasWine: bool,
    selectedItemId: string,
    getPrettyGroupName: func,
    hideMenu: bool,
    useGuided: bool,
    activeIndex: oneOfType([number, bool]),
    addonContainer: node,
    hasAddons: bool,
};

MobileCYOProductItemsVTwo.defaultProps = {
    /*
        The below '-' character is a special '-' character. The '-' coming from the CMS, was not matching
        my native '-' character, so I pulled it from the console, and it turns out the CMS is delivering a
        different Unicode version of '-'. I imagine it is an OS thing. I got that character from a unicode
        site, so be weary if you change this code. If the slicing stops working, it may be because your machine
        replaced this special '-' with a non-special '-'.
        Special: '–'
        Not:     '-'
        TODO: Figure out how to make more robust
    */
    getPrettyGroupName: (name) => (name.indexOf('–') > 0 ? name.slice(0, name.indexOf('–') - 1) : name),
    hideMenu: false,
    useGuided: true,
    activeIndex: false,
    selectedItemId: null,
    hasWine: false,
    itemAddedToCart: {},
    selectedAddons: [],
    addonContainer: () => null,
    hasAddons: false,
};

const mapStateToProps = (state) => ({
    itemAddedToCart: getAddToCartItemAdded(state),
});

export default connect(mapStateToProps)(MobileCYOProductItemsVTwo);
